// src/components/Sidebar.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import logo from '../assets/logo.png';

import {
  ClipboardDocumentListIcon,
  WrenchScrewdriverIcon,
  UserGroupIcon,
  ChartBarIcon,
  HomeIcon,
  ShoppingCartIcon,
  ClockIcon,
  CurrencyDollarIcon,
  ArrowUturnLeftIcon,
  TruckIcon // ⬅️ Ícono para “Pedidos” (si tu versión de heroicons no lo tiene, usa ClipboardDocumentListIcon)
} from '@heroicons/react/24/outline';

const Sidebar = () => {
  const [mostrarHistorial, setMostrarHistorial] = useState(false);
  const [mostrarFacturas, setMostrarFacturas] = useState(false);

  const { rol, cerrarSesion } = useUser();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await cerrarSesion();
    navigate('/login');
  };

  const puedeVer = (roles) => roles.includes(rol);

  if (!rol) return null;

  return (
    <div className="sidebar">
      <img src={logo} alt="Logo GLOBAL" className="sidebar-logo" />

      <div className="sidebar-title">
        <h2>FRENOS & MULTISERVICIOS</h2>
        <h1>GLOBAL</h1>
      </div>

      <nav className="sidebar-nav">
        {puedeVer(['admin', 'admin2', 'deposito', 'mecanico', 'vendedor']) && (
          <SidebarLink to="/" icon={<HomeIcon width={20} height={20} />} label="Inicio" />
        )}

        {puedeVer(['admin', 'admin2', 'deposito']) && (
          <SidebarLink to="/inventario" icon={<ClipboardDocumentListIcon width={20} height={20} />} label="Inventario" />
        )}

        {puedeVer(['admin', 'admin2', 'mecanico']) && (
          <SidebarLink to="/servicios" icon={<WrenchScrewdriverIcon width={20} height={20} />} label="Servicios" />
        )}

        {puedeVer(['admin', 'admin2']) && (
          <SidebarLink to="/clientes" icon={<UserGroupIcon width={20} height={20} />} label="Clientes" />
        )}

        {puedeVer(['admin', 'admin2', 'deposito', 'vendedor']) && (
          <SidebarLink to="/venta" icon={<ShoppingCartIcon width={20} height={20} />} label="Venta" />
        )}

        {/* NUEVO enlace a Pedidos */}
        {puedeVer(['admin', 'admin2', 'vendedor']) && (
          <SidebarLink to="/pedidos" icon={<TruckIcon width={20} height={20} />} label="Pedidos" />
        )}

        {puedeVer(['admin', 'admin2']) && (
          <>
            {/* Submenú Historial */}
            <button
              onClick={() => setMostrarHistorial(!mostrarHistorial)}
              className="sidebar-link"
              style={{ width: '100%', textAlign: 'left' }}
            >
              <ClockIcon width={20} height={20} className="text-[#ff4500]" />
              <span>Historial</span>
            </button>
            {mostrarHistorial && (
              <div style={{ paddingLeft: '1.5rem', marginTop: '0.3rem', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SidebarLink to="/historial-ventas" label="Historial Ventas" />
                <SidebarLink to="/historial-inventario" label="Historial Inventario" />
                <SidebarLink to="/retenciones" label="Retenciones" />
              </div>
            )}

            {/* Reporte y Registro de Pagos */}
            <SidebarLink to="/reporte" icon={<ChartBarIcon width={20} height={20} />} label="Reporte" />
            <SidebarLink to="/registro-pagos" icon={<CurrencyDollarIcon width={20} height={20} />} label="Registro de Pagos" />

            {/* Submenú Facturas */}
            <button
              onClick={() => setMostrarFacturas(!mostrarFacturas)}
              className="sidebar-link"
              style={{ width: '100%', textAlign: 'left' }}
            >
              <CurrencyDollarIcon width={20} height={20} />
              <span>Facturas</span>
            </button>
            {mostrarFacturas && (
              <div style={{ paddingLeft: '1.5rem', marginTop: '0.3rem', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SidebarLink to="/facturas-por-cobrar" label="Facturas por cobrar" />
                <SidebarLink to="/facturas" label="Facturas por pagar" />
              </div>
            )}
          </>
        )}

        {puedeVer(['admin', 'admin2', 'vendedor']) && (
          <SidebarLink to="/devoluciones" icon={<ArrowUturnLeftIcon width={20} height={20} />} label="Devoluciones" />
        )}
      </nav>

      <button onClick={handleLogout} className="logout-btn">
        Cerrar sesión
      </button>
    </div>
  );
};

const SidebarLink = ({ to, icon, label }) => (
  <Link to={to} className="sidebar-link">
    {icon}
    <span>{label}</span>
  </Link>
);

export default Sidebar;

